import { render } from "./ModTitlePreloaderComp.vue?vue&type=template&id=1e088e19&scoped=true&ts=true"
import script from "./ModTitlePreloaderComp.vue?vue&type=script&lang=ts"
export * from "./ModTitlePreloaderComp.vue?vue&type=script&lang=ts"

import "./ModTitlePreloaderComp.vue?vue&type=style&index=0&id=1e088e19&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e088e19"]])

export default __exports__